'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

if ((0, _jquery2.default)('.js-stockist-container').length) {
	var $mapContainer = (0, _jquery2.default)('.js-stockist-container');
	var $customElements = (0, _jquery2.default)('.custom-map-items');
	var customImage = $customElements.find('.custom-image');
	var customTitle = $customElements.find('.custom-title');
	var customSubTitle = $customElements.find('.custom-sub-title');

	var targetElement = document.querySelector('.js-stockist-container');
	// Options for the observer (which mutations to observe)
	var config = {
		attributes: true,
		childList: true,
		subtree: true
	};

	// Callback function to execute when mutations are observed
	var callback = function callback(mutationsList, observer) {
		// Use traditional 'for loops' for IE 11
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = mutationsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var mutation = _step.value;

				if (mutation.type === 'childList') {
					// create custom slider for reviews widget
					addCustomElements(customImage, customTitle, customSubTitle);
					return;
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	};

	// Create an observer instance linked to the callback function
	var observer = new MutationObserver(callback);

	// Start observing the target node for configured mutations
	observer.observe(targetElement, config);
}

function addCustomElements(el1, el2, el3) {
	if (!(0, _jquery2.default)('.stockist-intro').length && (0, _jquery2.default)('.stockist-search-form').length) {
		(0, _jquery2.default)('.stockist-search-form').wrap('<div class="stockist-intro" ><div class="stockist-intro__inner"></div></div>');
		(0, _jquery2.default)('.stockist-intro .stockist-intro__inner').prepend(el1).prepend(el2);
	}

	if ((0, _jquery2.default)('.stockist-side-panel').length && !(0, _jquery2.default)('.appended').length) {
		(0, _jquery2.default)('.stockist-side-panel').prepend(el3);
		(0, _jquery2.default)('.stockist-side-panel').addClass('appended');
	}
}